import { AlertAction } from '@/components/ui/alert';
import { Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AddOrganizationAction = () => {
  const navigate = useNavigate();

  const onClickButton = (): void => {
    navigate('/register/organization', {
      state: {
        returnTo: '/'
      }
    });
  };

  return (
    <AlertAction
      className="hover:!bg-accent-soft active:!bg-accent-soft"
      hint="для работы с поставками и документами"
      icon={<Building2 className="size-5" strokeWidth={1.75} />}
      label="Добавьте организацию"
      onClick={onClickButton}
    />
  );
};

export default AddOrganizationAction;